import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './Dashboard.css';

const Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [enrollments, setEnrollments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const coursesRes = await api.get('/courses');
      setCourses(Array.isArray(coursesRes.data) ? coursesRes.data : []);

      try {
        const enrollmentsRes = await api.get('/enrollments/my-enrollments');
        setEnrollments(Array.isArray(enrollmentsRes.data) ? enrollmentsRes.data : []);
      } catch (enrollError) {
        console.log('Rotas de matrícula ainda não implementadas');
        setEnrollments([]);
      }
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      setCourses([]);
      setEnrollments([]);
    } finally {
      setLoading(false);
    }
  };

  const handleEnroll = async (courseId) => {
    try {
      const response = await api.post('/enrollments', { course_id: courseId });
      
      if (response.data.payment_required) {
        alert('Curso adicionado! Prossiga para o pagamento.');
      } else {
        alert('Matrícula realizada com sucesso!');
        const dest = courseId === 9 ? '/treinamento' : `/course/${courseId}`;
        setTimeout(() => navigate(dest), 1000);
      }
      
      loadData();
    } catch (error) {
      if (error.response?.status === 400) {
        alert(error.response.data.error || 'Você já está matriculado neste curso');
      } else {
        alert('Erro ao realizar matrícula. Tente novamente.');
      }
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  const enrolledCourseIds = enrollments.map(e => e.course_id);
  const availableCourses = courses.filter(c => !enrolledCourseIds.includes(c.id));
  const completedCount = enrollments.filter(e => e.progress >= 100).length;

  return (
    <div className="dashboard">
      {/* Header Profissional */}
      <header className="dashboard-header">
        <div className="header-top">
          <div className="brand">
            <h1>Marcel<span>Scur</span></h1>
            <p className="tagline">Plataforma de Cursos</p>
          </div>
          <div className="user-section">
            <div className="user-info">
              <div className="user-avatar">
                {user?.name?.charAt(0).toUpperCase()}
              </div>
              <div className="user-details">
                <span className="user-name">{user?.name}</span>
                <span className="user-email">{user?.email}</span>
              </div>
            </div>
            <button onClick={handleLogout} className="btn-logout">
              Sair
            </button>
          </div>
        </div>
      </header>

      {/* Stats Profissionais */}
      <section className="stats-section">
        <div className="stats-container">
          <div className="stat-card">
            <div className="stat-value">{enrollments.length}</div>
            <div className="stat-label">Cursos Ativos</div>
            <div className="stat-bar"></div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{completedCount}</div>
            <div className="stat-label">Concluídos</div>
            <div className="stat-bar"></div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{courses.length}</div>
            <div className="stat-label">Total Disponível</div>
            <div className="stat-bar"></div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{completedCount}</div>
            <div className="stat-label">Certificados</div>
            <div className="stat-bar"></div>
          </div>
        </div>
      </section>

      {/* Cursos Matriculados */}
      {enrollments.length > 0 && (
        <section className="my-courses-section">
          <div className="section-header">
            <h2>Meus Cursos</h2>
            <div className="section-line"></div>
          </div>
          <div className="courses-grid">
            {enrollments.map((enrollment) => (
              <div key={enrollment.id} className="course-card">
                <div className="course-thumbnail">
                  <div className="thumbnail-overlay">
                    <span className="course-category">Em Andamento</span>
                  </div>
                </div>
                <div className="course-content">
                  <h3>{enrollment.course_title}</h3>
                  <p>{enrollment.course_description}</p>
                  <div className="progress-section">
                    <div className="progress-bar">
                      <div 
                        className="progress-fill" 
                        style={{ width: `${enrollment.progress || 0}%` }}
                      ></div>
                    </div>
                    <span className="progress-text">{(parseFloat(enrollment.progress) || 0).toFixed(2)}% concluído</span>
                  </div>
                  <Link 
                    to={enrollment.course_id === 9 ? '/treinamento' : `/course/${enrollment.course_id}`}
                    className="btn btn-primary"
                  >
                    Continuar Estudando
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Cursos Disponíveis */}
      {availableCourses.length > 0 && (
        <section className="available-courses-section">
          <div className="section-header">
            <h2>Cursos Disponíveis</h2>
            <div className="section-line"></div>
          </div>
          <div className="courses-grid">
            {availableCourses.map((course) => (
              <div key={course.id} className="course-card">
                <div className="course-thumbnail">
                  <div className="thumbnail-overlay">
                    <span className="course-price">R$ {course.price}</span>
                  </div>
                </div>
                <div className="course-content">
                  <h3>{course.title}</h3>
                  <p>{course.description}</p>
                  <div className="course-meta">
                    <span>{course.duration_hours}h de conteúdo</span>
                  </div>
                  <button 
                    onClick={() => handleEnroll(course.id)}
                    className="btn btn-primary"
                  >
                    Matricular-se
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default Dashboard;
